import { useId } from "react";

/** EvalHid logo: a piezometer — a borehole crossing soil layers down to the aquifer's recharge point. */
export function Logo({ size = 32 }: { size?: number }) {
  const uid = useId();
  const g = (name: string) => `${name}-${uid}`;

  return (
    <svg width={size} height={size} viewBox="0 0 100 100" aria-hidden="true">
      <defs>
        <linearGradient id={g("bg")} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#145b68" />
          <stop offset="1" stopColor="#0d4650" />
        </linearGradient>
      </defs>

      <rect x="1.5" y="1.5" width="97" height="97" rx="26" fill={`url(#${g("bg")})`} />

      <path
        d="M20,32 A32,14 0 0 0 80,32"
        fill="none"
        stroke="#3fa7b3"
        strokeWidth="3"
        opacity="0.55"
      />
      <path
        d="M20,48 A32,14 0 0 0 80,48"
        fill="none"
        stroke="#cfe9ec"
        strokeWidth="3"
        opacity="0.7"
      />
      <path
        d="M20,64 A32,14 0 0 0 80,64"
        fill="none"
        stroke="#cfe9ec"
        strokeWidth="3.4"
        opacity="0.9"
      />
      <line
        x1="50"
        y1="16"
        x2="50"
        y2="76"
        stroke="#eaf6f6"
        strokeWidth="4.5"
        strokeLinecap="round"
      />
      <circle cx="50" cy="78" r="6.5" fill="#e0913f" />
    </svg>
  );
}

export function Wordmark({ size = 22 }: { size?: number }) {
  return (
    <span className="wordmark" style={{ fontSize: size }}>
      Eval<strong>Hid</strong>
    </span>
  );
}
